/**
 * Dashboard - customer tools to sidebar
 */
(() => {
  const dashboard = document.querySelector('.myaccountdashboard_container');
  if (!dashboard) return;

  document.body.classList.add('ex-dashboard');

  const customerTools = document.querySelector('.customertools');

  document.querySelectorAll('.dashboard-links').forEach((item) => {
    item.append(customerTools.cloneNode(true));
  });

  document.querySelectorAll('.dashboard-links .nav-pills').forEach((item) => {
    item.insertAdjacentHTML('afterbegin', '<li class="sidebar-opentools"><a class="js-customer-tools" href="javascript:;"><i class="fa fa-tachometer"></i><span>Customer Tools</span></li>');
  });

  document.querySelector('.myaccount.container > .desktop').classList.add('row');
})();

/**
 * Account Manager
 */
(() => {
  const managerWrapper = document.querySelector('.account-manager');
  if (!managerWrapper) return;

  // eslint-disable-next-line no-undef
  const managerData = EvoXLayer().session.account_manager;

  if (Object.keys(managerData).length === 0) return;

  const photo = managerData.image || 'https://us.evocdn.io/dealer/1334/content/media/My_Theme/ob-profile-ph.png';
  const { name } = managerData;
  const { title } = managerData;
  const { phone } = managerData;
  const { cell } = managerData;
  const { fax } = managerData;
  const { email } = managerData;

  let htmlTemplate = [];

  if (photo) {
    htmlTemplate += `<img height="78px" width="78px" src="${photo}" alt="${name}" />`;
  }
  htmlTemplate += '<span>';
  if (name) {
    htmlTemplate += `<h3>${name}</h3>`;
  }
  if (title) {
    htmlTemplate += `<p>${title}</p>`;
  }
  htmlTemplate += '</span>';
  htmlTemplate += '<ul class="nList">';
  if (phone) {
    htmlTemplate += `<li><img width="16px" height="16px" src="https://us.evocdn.io/dealer/1334/content/media/My_Theme/ob-icon-tel.svg" /><a href="tel:${phone.replace(/\s+/g, '')}">${phone}</a></li>`;
  }
  if (cell) {
    htmlTemplate += `<li><img width="16px" height="16px" src="https://us.evocdn.io/dealer/1334/content/media/My_Theme/ob-icon-tel.svg" /><a href="tel:${cell.replace(/\s+/g, '')}">${cell}</a></li>`;
  }
  if (fax) {
    htmlTemplate += `<li><img width="16px" height="16px" src="https://us.evocdn.io/dealer/1334/content/media/My_Theme/ob-icon-fax.svg" /><a href="tel:${fax.replace(/\s+/g, '')}">${fax}</a></li>`;
  }
  if (email) {
    htmlTemplate += `<li class="manager-email"><img width="16px" height="16px" src="https://us.evocdn.io/dealer/1334/content/media/My_Theme/ob-icon-email.svg" /><a href="mailto:${email}">${email}</a></li>`;
  }
  htmlTemplate += '</ul>';

  document.querySelectorAll('.account-manager').forEach((item) => {
    item.insertAdjacentHTML('afterbegin', htmlTemplate);
    item.classList.add('nLoaded');
  });
})();
